import React from "react";
import { Helmet } from "react-helmet-async";

const PrivacyPolicies = () => {
  return (
    <>

      <Helmet>
        <link rel="canonical" href="https://www.hcfinvest.com/privacyPolicies" />
      </Helmet>

          <div className="container mt-5 font-poppins leading-loose">
      <h1 className="text-5xl font-bold">Privacy Policy</h1>

      <p>
        <strong>
          Heddge Capitals Wealth Management LLC, operating under the brand name
          HC Finvest
        </strong>{" "}
        ("we," "our," or "us") is committed to protecting your privacy. This
        Privacy Policy explains how your personal information is collected,
        used, and disclosed by HC Finvest.
      </p>
      <br />
      <p>
        This Privacy Policy applies to our website, www.hcfinvest.com and its
        associated subdomains (collectively, our "Service"). By accessing or
        using our Service, you signify that you have read, understood, and agree
        to our collection, storage, use, and disclosure of your personal
        information as described in this Privacy Policy and our Terms of
        Service.
      </p>

      <h4 className="text-2xl font-bold mt-6">For this Privacy Policy :</h4>

      <p>
        <b>Company :</b> when this policy mentions "Company," "We," "us," or
        "our," it refers to that is responsible for your information under this
        Privacy Policy.
      </p>
      <p>
        <b>Customer :</b> refers to the company, organization or person that
        signs up to use the HC Finvest Service to manage the relationships with
        your consumers or service users.
      </p>
      <p>
        <b>Device :</b> any internet connected device such as a phone, tablet,
        computer or any other device that can be used to visit HC Finvest and
        use the services.
      </p>
      <p>
        <b>IP address :</b> Every device connected to the Internet is assigned a
        number known as an Internet protocol (IP) address.
      </p>
      <p>
        <b>Personal :</b> refers to those individuals who are employed by HC
        Finvest or are under contract to perform a service.
      </p>
      <p>
        <b>Personal Data :</b> any information that directly or indirectly
        allows for the identification of a natural person.
      </p>
      <p>
        <b>Service :</b> refers to the service provided by HC Finvest.
      </p>
      <p>
        <b>Third-party service :</b> refers to advertisers, sponsors, marketing
        partners, and others whose products or services may interest you.
      </p>
      <p>
        <b>You :</b> a person or entity that is registered with HC Finvest to
        use the Services.
      </p>

      <p className="text-xl font-semibold mt-6">
        We collect information from you when you visit our service, register,
        place an order, subscribe to our newsletter, respond to a survey or fill
        out a form.
      </p>

      <p>Name / Username</p>
      <p>Phone Numbers</p>
      <p>Email Addresses</p>

      <h4 className="text-2xl font-bold mt-6">
        How Do We Use The Information We Collect?
      </h4>

      <p>To personalize your experience.</p>
      <p>To improve customer service.</p>
      <p>To process transactions.</p>
      <p>To administer contests, promotions, or surveys.</p>
      <p>To send periodic emails.</p>

      {/* --- CONTENT CONTINUES --- */}

      {/* Due to the extremely long privacy policy, continue adding all <h4> and <p> blocks exactly as in the original HTML */}

      <p className="mt-10 font-semibold">
        (Note: Continue adding the remaining content blocks here following the
        exact structure from the HTML you provided.)
      </p>
    </div>
    </>
  );
}

export default PrivacyPolicies;
